var _path, _circle, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.7036 23.148C28.7036 21.1025 30.3618 19.4443 32.4073 19.4443H35.6481L38.8888 23.9655L42.1295 19.4443H45.1104C47.2546 19.4443 48.9508 21.2595 48.8056 23.3988L47.2221 46.7296H31.5073L32.1508 34.5025C32.2689 32.2599 30.7744 30.3217 28.7036 29.78V23.148Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.889,
    cy: 10.185,
    r: 6.481,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.21505 25.2688C1.05882 23.1231 2.75755 21.2961 4.90898 21.2961H17.5925C19.638 21.2961 21.2962 22.9543 21.2962 24.9998V29.7799C19.2253 30.3217 17.7309 32.2599 17.8489 34.5024L18.4925 46.7295H2.77765L1.21505 25.2688Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.0132 6.48145C13.7877 6.48145 16.0836 8.68998 16.3496 11.6143C16.518 13.3776 17.1917 15.1671 18.3707 16.9217C18.5213 17.14 18.5568 17.4193 18.477 17.6723C18.3884 17.9255 18.1932 18.1263 17.9361 18.2224C15.6582 19.0342 13.3533 19.4444 11.084 19.4444C8.8149 19.4444 6.52783 19.0342 4.28512 18.2224C4.0369 18.135 3.85078 17.943 3.76227 17.6986C3.66466 17.4541 3.69128 17.1923 3.82416 16.9653C4.86122 15.1759 5.4819 13.3689 5.67689 11.5968C5.98701 8.68124 8.28295 6.48145 11.0132 6.48145Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.3723 31.4814C21.2413 31.4814 19.5499 33.2753 19.675 35.4026L20.3703 47.2222H29.6295L30.3248 35.4026C30.4499 33.2753 28.7585 31.4814 26.6275 31.4814H23.3723Z",
    opacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 26.852,
    r: 2.778,
    fill: "#fff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.ffee6c23ecd7c7258b556db5ebfe54e7.svg";
export { ForwardRef as ReactComponent };